import { createContext } from "react";

import { TagColor } from "./types";

export const TagEllipsisContext = createContext(false);

// Color of the surface under the tag: a light tag of that same color would vanish, so it gets a border.
// Context goes through portals: surfaces with their own background (modal, popover…) reset it.
export const TagSurfaceContext = createContext<TagColor | undefined>(undefined);
